import localforage from "localforage";

const HOLD_KEY = 'held_orders';

export const saveHoldOrder = async (order) => {
    const existing = await getHoldOrders();
    const newOrder = { ...order, id: Date.now() }; // temporary id
    await localforage.setItem(HOLD_KEY, [newOrder, ...existing]);
    return newOrder;
};

export const getHoldOrders = async () => {
    const data = await localforage.getItem(HOLD_KEY);
    return data || [];
};

export const deleteHoldOrder = async (id) => {
    const existing = await getHoldOrders();
    const updated = existing.filter(order => order.id !== id);
    await localforage.setItem(HOLD_KEY, updated);
};
